
function convertTime12to24(uTime, uDate) {
    let time = uTime.split(':');
    let date = uDate.split('-');
    return new Date(Date.UTC(parseInt(date[0]), parseInt(date[1]) - 1, parseInt(date[2]), parseInt(time[0]), parseInt(time[1]))).toLocaleString('en-US', {timeZone: 'America/New_York', hour12: false }).split(',');
  }
  export default convertTime12to24;
  